module.exports = __webpack_public_path__ + "59c64077e13d91d2c52dcfb4a7578a17.woff2";